/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingTabletMutationRequest, PostApiBookingTabletMutationResponse, PostApiBookingTabletQueryParams, PostApiBookingTablet400, PostApiBookingTablet403, PostApiBookingTablet404, PostApiBookingTablet500 } from "../entities/PostApiBookingTablet";

function getPostApiBookingTabletUrl() {
  const res = { method: 'POST', url: `/api/booking/tablet` as const }
  return res
}

/**
 * @description Создание записи без телефона в выбранном филиале: услуга компании по типу, ближайшее время, single/parallel/sequential
 * @summary Создать запись с планшета
 * {@link /api/booking/tablet}
 */
export async function postApiBookingTablet(data: PostApiBookingTabletMutationRequest, params: PostApiBookingTabletQueryParams, config: Partial<RequestConfig<PostApiBookingTabletMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBookingTabletMutationResponse, ResponseErrorConfig<PostApiBookingTablet400 | PostApiBookingTablet403 | PostApiBookingTablet404 | PostApiBookingTablet500>, PostApiBookingTabletMutationRequest>({ method : "POST", url : getPostApiBookingTabletUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}